<div class="notification-info" *ngIf="data">
  <div class="info-item">
    <mat-icon [svgIcon]="'clock'" class="square-icon info-item-icon"></mat-icon>
    {{ formatDateDifference(data.date) }}
  </div>

  <div class="info-item">
    <mat-icon [svgIcon]="'info-2'" class="square-icon info-item-icon"></mat-icon>
    {{ data.position }}
  </div>
</div>

<h4 *ngIf="data.title" class="notification-title">{{ data.title }}</h4>

<div class="notification-text-box" [@openClose]="showFullText ? 'opened' : 'closed'">
  <div class="notification-text">
    {{ data.text }}
  </div>
  <div class="notification-external-link" >
    <!-- Conditionally render the link only if MessageExternalUrl is present -->
    <a *ngIf="data.externalUrl" [href]="data.externalUrl" target="_blank">{{ data.linkText }}</a>
  </div>
</div>

<div *ngIf="fullText" class="full-text-box">
  <button class="no-style full-text-btn" (click)="showFullText = !showFullText">
    <span class="text">{{ showFullText ?  settings.readLessBtnText : settings.readMoreBtnText}}</span>
    <mat-icon [svgIcon]="showFullText ? 'minus-2' : 'plus-2'" class="square-icon full-text-icon"></mat-icon>
  </button>
</div>
